<h3 id="name">{{categoryName|uppercase}}</h3>
<div class="cate">
    <bm-product *ngFor="let product of products" title="{{product.name}}" price="{{product.price}}"
        promotion_price="{{product.promotionPrice}}" image="{{product.image}}" routerLink="/producto/{{product.code}}" onDemand="{{product.onDemand}}"></bm-product>
</div>